module.exports = __webpack_public_path__ + "img/vsystems_logo.bfab3cee.svg";